import { dehydrate, QueryClient } from '@tanstack/react-query';
import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import { ARTICLE_BY_GROUP } from 'src/constants/services';
import { medicineListQueryKey } from 'src/hooks/Medicine/useMedicineList';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';
import { getLayoutMobileServer } from 'src/utils/layout-mobile';

const HeadC = dynamic(() => import('src/components/Head'));
const InfoObatLayout = dynamic(() => import('src/components/Layout/InfoObat'));
const SearchObat = dynamic(() => import('src/containers/InfoObat/Search'));
const TabObat = dynamic(() => import('src/containers/InfoObat/Tab'));

const InfoObatPage = () => {
	return (
		<>
			<HeadC
				title="Informasi Direktori Obat"
				description={
					'Ketahui informasi mengenai direktori obat terbaru dan terlengkap. ' +
					'Mulai dari pengertian, keterangan, kegunaan dan dosis aturan pakai hanya ' +
					'di KlikDokter.'
				}
			/>

			<InfoObatLayout header={<SearchObat />} adSource="obat" adTarget={[['channel', ['obat']]]}>
				<TabObat />
			</InfoObatLayout>
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store) => async (ctx) => {
		const queryClient = new QueryClient();

		await store.dispatch(actionGetMenu());
		await store.dispatch(actionGetFooterMenu());

		const page = Number(ctx?.query?.page) || 1;
		const alphabet = ctx?.query?.alphabet || 'a';

		await queryClient.prefetchQuery({
			queryKey: [medicineListQueryKey, page, alphabet],
			queryFn: () =>
				fetchApiV3Publishing({
					url: `${ARTICLE_BY_GROUP.service}/all`,
					options: { method: 'GET' },
					payload: {
						start_with: alphabet,
						type: ARTICLE_BY_GROUP.model.obat,
						order: 'asc',
						order_by: 'slug',
						page,
						per_page: 50,
					},
				}),
		});
		return {
			props: {
				card: true,
				dehydratedState: dehydrate(queryClient),
				isWhiteBackground: true,
				pageHeaderContent: {
					title: 'Obat',
					breadcrumbs: [{ label: 'Obat' }],
				},
				layoutMobile: getLayoutMobileServer(ctx),
			},
		};
	},
);

export default InfoObatPage;
